class GlobalError {
  constructor() {
    this.subscriber = null;
  }

  subscribe(fn) {
    this.subscriber = fn;
  }

  show(title = "Error", message = "Something went wrong") {
    this.subscriber?.({ title, message });
  }
}

export const globalError = new GlobalError();
